module.exports = __webpack_public_path__ + "f129d2fa06514dcde6a9b1699c241330.png";